exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js!sweetalert2/dist/sweetalert2.min.css"), "");

// module
exports.push([module.id, "html, body {\n  height: 100%;\n  font-family: Arial, Helvetica, sans-serif; }\n\na.active {\n  background-color: gray; }\n\n*:focus,\n*:active {\n  box-shadow: none;\n  outline: none; }\n\np:empty {\n  display: none; }\n\n.cursor-pointer {\n  cursor: pointer; }\n\n.bg-no-repeat {\n  background-repeat: no-repeat; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/app/app.component.scss
// module id = 264
// module chunks = 4